;(function($) {
/* ==========================================================================
 * custom theme template
 *
 * general scripts
 *
========================================================================== */
/* name space init
-------------------------------------*/
window.MY_PROJECT = window.MY_PROJECT || {};

/* work timing instant
----------------------- */
$(function(){

/* sample
---------------------------------------------- */
(function (){
// ここに処理を書く
})();

});
/* work timing instant */


/* work timing ready
----------------------- */
$(document).on('ready',function(){

$(".nav--header").find(".list-item__pulldown").hover(function() {
	$(this).find(".nav__pulldown").addClass("active");
}, function() {
	$(this).find(".nav__pulldown").removeClass("active");
});

/* slick
---------------------------------------------- */
if ($('.firstview')[0]) {
	$('.firstview__slider').slick({
		autoplay: true,
		autoplaySpeed: 5000,
		dots: true,
		arrows: false
	});
};/* end if */

/* izimodal
---------------------------------------------- */
if ($('.izimodal')[0]) {
	$('.izimodal').iziModal();

	$(document).on('click', '.modal-trigger', function (e){
		e.preventDefault();

		const target = $(e.target).attr('href');
		$(target).iziModal('open');
	});
};/* end if */


/* scroll
----------------------- */
if ($('*[data-fixed-nav]')[0]) {
(function () {
	var globalNav = $('*[data-fixed-nav]');
	var globalNavPos = globalNav.offset();

	$(window).on('load scroll', function () {
		scrollPos = $(this).scrollTop();

		if (scrollPos > globalNavPos.top) {
			globalNav.attr('data-fixed-nav','fixed');
		} else {
			globalNav.attr('data-fixed-nav','');
		};
	});
})();
};/* end if */


/* menu
----------------------- */
if ($('#js-nav-toggle')[0]) {
	(function (){
		$('#js-nav-toggle').on('click',function(){
			$(this).toggleClass('active')
			$('.sub-nav-wrap').toggle()
			switch(location.pathname.split("/")[1]){
				case 'tokyo_top':
					$('#js-nav-target-tokyo').toggle();
				break;
				case 'fukuoka_top':
					$('#js-nav-target-fukuoka').toggle();
				break;
				default:
					$('#js-nav-target-tokyo').toggle();
					$('#js-nav-target-fukuoka').toggle();
			}
		})
	})();
};

});/* work timing ready */


/* work timing load
----------------------- */
$(window).on('load',function(){

/* sample
---------------------------------------------- */
if ($('.seelctor')[0]) {
(function (){
// ここに処理を書く
})();
};/* end if */


});/* work timing load */


})(jQuery);
